import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, BehaviorSubject } from 'rxjs';
import { throwError } from 'rxjs/internal/observable/throwError';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment.prod';
import { ConfigService } from '../config.service';
import { NavMenuItems } from '../Models/NavMenuItems';
export interface UserData {
  userId: number;
  agencyId: string;
  fullName: string;
  phone: string;
  email: string;
  parentAgency: string;
  parentHierarchy: string;
  immediateParent: string;
  userActive: boolean;
  backSystemCompanyId: number;
  backSystemCompanyCustomer: string;
  agencyCurrency: string;
}

@Injectable({
  providedIn: 'root'
})
//export class AuthService implements OnDestroy {
//  isLoggedIn: boolean = false
  
//  constructor(private configService: ConfigService,private router: Router, private http: HttpClient,) {
//  }
//  get config(): any {
//    return this.configService.getConfigData();
//  }
//  public login = () => {
//    this.isLoggedIn = true
//    window.localStorage.clear();
//    this.router.navigate(['/']);
//  }
//  public logOut = () => {
//    this.isLoggedIn = false
//    localStorage.clear();
//    this.logoutCall().subscribe({
//      next: (data) => {

//        this.router.navigate(['/']);

//      }, error: () => {
//        this.router.navigate(['/']);
//      }
//    });

//  }
//  logoutCall(): Observable<boolean> {
//    console.log(this.config.baseUrl);
//    return this.http.get<boolean>(this.config.baseUrl + '/Login/Logout')
//      .pipe(map((data: any) => {
//        return data;
//      }), catchError(error => { return throwError(error); }))
//  }

//  ngOnDestroy() {
//  }

//}
export class AuthService implements OnDestroy {
  isLoggedIn: boolean = false;
  private userDataSubject = new BehaviorSubject<UserData | null>(null);
  userData$ = this.userDataSubject.asObservable();

  private navMenuSubject = new BehaviorSubject<NavMenuItems | null>(null);
  navMenu$ = this.navMenuSubject.asObservable();

  constructor(
    private configService: ConfigService,
    private router: Router,
    private http: HttpClient
  ) {
    this.loadUserFromStorage();
    this.loadNavMenuFromStorage();
  }

  private loadUserFromStorage() {
    const userId = localStorage.getItem("UserId");
    if (userId) {
      this.isLoggedIn = true;
      this.userDataSubject.next(this.getUserDataFromStorage());
    }
  }

  private loadNavMenuFromStorage() {
    const navMenu = localStorage.getItem("UserNavMenu");
    if (navMenu) {
      try {
        this.navMenuSubject.next(JSON.parse(navMenu));
      } catch (e) {
        console.error('Error parsing nav menu', e);
      }
    }
  }

  private getUserDataFromStorage(): UserData {
    return {
      userId: Number(localStorage.getItem("UserId")),
      agencyId: localStorage.getItem("AgencyId") || '',
      fullName: localStorage.getItem("fullName") || '',
      phone: localStorage.getItem("Phone") || '',
      email: localStorage.getItem("Email") || '',
      parentAgency: localStorage.getItem("ParentAgency") || '',
      parentHierarchy: localStorage.getItem("ParentHierarchy") || '',
      immediateParent: localStorage.getItem("ImmediateParent") || '',
      userActive: localStorage.getItem("UserActive") === 'true',
      backSystemCompanyId: Number(localStorage.getItem("BackSystemCompanyId")) || 0,
      backSystemCompanyCustomer: localStorage.getItem("BackSystemCompanyCustomer") || '',
      agencyCurrency: localStorage.getItem("AgencyCurrency") || ''
    };
  }

  get config(): any {
    return this.configService.getConfigData();
  }

  public login = () => {
    this.isLoggedIn = true;
    this.router.navigate(['/']);
  }

  public setNavMenu(navMenu: NavMenuItems) {
    localStorage.setItem("UserNavMenu", JSON.stringify(navMenu));
    this.navMenuSubject.next(navMenu);
  }

  public logOut = () => {
    this.isLoggedIn = false;
    localStorage.clear();
    this.userDataSubject.next(null);
    this.navMenuSubject.next(null);
    this.logoutCall().subscribe({
      next: (data) => {
        this.router.navigate(['/']);
      }, error: () => {
        this.router.navigate(['/']);
      }
    });
  }

  logoutCall(): Observable<boolean> {
    return this.http.get<boolean>(this.config.baseUrl + '/Login/Logout')
      .pipe(
        map((data: any) => data),
        catchError(error => throwError(error))
      );
  }

  // Permission check methods
  hasPermission(permissionKey: keyof NavMenuItems): boolean {
    const navMenu = this.navMenuSubject.value;
    if (!navMenu) return false;
    return navMenu[permissionKey] === true;
  }

  hasAnyPermission(permissionKeys: (keyof NavMenuItems)[]): boolean {
    const navMenu = this.navMenuSubject.value;
    if (!navMenu) return false;
    return permissionKeys.some(key => navMenu[key] === true);
  }

  hasAllPermissions(permissionKeys: (keyof NavMenuItems)[]): boolean {
    const navMenu = this.navMenuSubject.value;
    if (!navMenu) return false;
    return permissionKeys.every(key => navMenu[key] === true);
  }

  // Report rights check
  hasReportAccess(reportName: string): boolean {
    const navMenu = this.navMenuSubject.value;
    if (!navMenu || !navMenu.reportUserRights) return false;

    // Find the latest entry for this report
    const latestReport = navMenu.reportUserRights
      .filter(r => r.reportTypeName === reportName)
      .sort((a, b) => b.reportAgencyRightId - a.reportAgencyRightId)[0];

    return latestReport ? latestReport.status : false;
  }

  hasAnyReportAccess(reportNames: string[]): boolean {
    const navMenu = this.navMenuSubject.value;
    if (!navMenu || !navMenu.reportUserRights) return false;

    // If data is already deduplicated, simple find works
    // But to be safe, we still check all entries
    return reportNames.some(reportName => {
      return navMenu.reportUserRights.some(
        reportRight => reportRight.reportTypeName === reportName && reportRight.status === true
      );
    });
  }

  // Check if user is active
  isUserActive(): boolean {
    return localStorage.getItem("UserActive") === 'true';
  }

  // Get user ID
  getUserId(): number {
    return Number(localStorage.getItem("UserId")) || 0;
  }

  // Get Agency ID
  getAgencyId(): string {
    return localStorage.getItem("AgencyId") || '';
  }

  ngOnDestroy() { }
}
